export const THEMES = [
  {
    id: 'golden',
    name: '✨ Golden Hour',
    dark: {
      '--bg-body':        '#1a1208',
      '--bg-header':      'rgba(22,14,6,0.88)',
      '--bg-caps':        'rgba(20,12,4,0.7)',
      '--bg-input-area':  'rgba(14,8,2,0.94)',
      '--bg-input-row':   'rgba(200,169,126,0.05)',
      '--bg-msg-bot':     'rgba(242,234,217,0.06)',
      '--bg-msg-user':    '#3d3028',
      '--bg-typing':      'rgba(242,234,217,0.06)',
      '--bg-card':        'rgba(30,20,10,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#1a1208 0%,#231a0f 40%,#1e1508 100%)',
      '--grad-r1':        'rgba(200,169,126,0.08)',
      '--grad-r2':        'rgba(184,92,56,0.06)',
      '--text-main':      '#f2ead9',
      '--text-input':     '#faf6ef',
      '--text-ph':        'rgba(200,169,126,0.3)',
      '--accent':         '#c8a97e',
      '--accent2':        '#a07850',
      '--accent3':        '#d4bb95',
      '--border-header':  'rgba(200,169,126,0.18)',
      '--border-caps':    'rgba(200,169,126,0.1)',
      '--border-input':   'rgba(200,169,126,0.12)',
      '--border-input-f': 'rgba(200,169,126,0.5)',
      '--border-card':    'rgba(200,169,126,0.2)',
      '--border-chip':    'rgba(200,169,126,0.2)',
      '--online-border':  '#1a1208',
      '--scrollbar':      'rgba(200,169,126,0.2)',
      '--send-grad':      'linear-gradient(135deg,#a07850,#c8a97e)',
      '--meta-color':     '#1a1208',
    },
    light: {
      '--bg-body':        '#f5ede0',
      '--bg-header':      'rgba(255,248,238,0.95)',
      '--bg-caps':        'rgba(248,240,225,0.95)',
      '--bg-input-area':  'rgba(252,246,236,0.98)',
      '--bg-input-row':   'rgba(160,110,60,0.06)',
      '--bg-msg-bot':     'rgba(255,248,238,0.9)',
      '--bg-msg-user':    '#e8d8c0',
      '--bg-typing':      'rgba(255,248,238,0.9)',
      '--bg-card':        'rgba(255,248,238,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#f5ede0 0%,#ede0cc 40%,#f0e6d0 100%)',
      '--grad-r1':        'rgba(160,110,60,0.08)',
      '--grad-r2':        'rgba(180,90,40,0.05)',
      '--text-main':      '#3a2a18',
      '--text-input':     '#2a1a08',
      '--text-ph':        'rgba(120,80,40,0.4)',
      '--accent':         '#9a6830',
      '--accent2':        '#7a5020',
      '--accent3':        '#b88840',
      '--border-header':  'rgba(160,110,60,0.2)',
      '--border-caps':    'rgba(160,110,60,0.15)',
      '--border-input':   'rgba(160,110,60,0.2)',
      '--border-input-f': 'rgba(160,110,60,0.55)',
      '--border-card':    'rgba(160,110,60,0.2)',
      '--border-chip':    'rgba(160,110,60,0.22)',
      '--online-border':  '#f5ede0',
      '--scrollbar':      'rgba(160,110,60,0.2)',
      '--send-grad':      'linear-gradient(135deg,#7a5020,#9a6830)',
      '--meta-color':     '#f5ede0',
    },
  },
  {
    id: 'rose',
    name: '🌸 Rose Petal',
    dark: {
      '--bg-body':        '#160a0e',
      '--bg-header':      'rgba(22,8,14,0.88)',
      '--bg-caps':        'rgba(18,6,10,0.7)',
      '--bg-input-area':  'rgba(10,4,6,0.94)',
      '--bg-input-row':   'rgba(220,130,160,0.05)',
      '--bg-msg-bot':     'rgba(255,220,235,0.06)',
      '--bg-msg-user':    '#3a1828',
      '--bg-typing':      'rgba(255,220,235,0.06)',
      '--bg-card':        'rgba(30,10,18,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#160a0e 0%,#200f16 40%,#1a0c12 100%)',
      '--grad-r1':        'rgba(220,130,160,0.09)',
      '--grad-r2':        'rgba(200,60,100,0.06)',
      '--text-main':      '#f5dde8',
      '--text-input':     '#fce8f0',
      '--text-ph':        'rgba(220,130,160,0.35)',
      '--accent':         '#e8809a',
      '--accent2':        '#c05070',
      '--accent3':        '#f0a0b8',
      '--border-header':  'rgba(220,130,160,0.18)',
      '--border-caps':    'rgba(220,130,160,0.1)',
      '--border-input':   'rgba(220,130,160,0.12)',
      '--border-input-f': 'rgba(220,130,160,0.5)',
      '--border-card':    'rgba(220,130,160,0.2)',
      '--border-chip':    'rgba(220,130,160,0.2)',
      '--online-border':  '#160a0e',
      '--scrollbar':      'rgba(220,130,160,0.2)',
      '--send-grad':      'linear-gradient(135deg,#c05070,#e8809a)',
      '--meta-color':     '#160a0e',
    },
    light: {
      '--bg-body':        '#fff0f5',
      '--bg-header':      'rgba(255,240,248,0.95)',
      '--bg-caps':        'rgba(252,235,245,0.95)',
      '--bg-input-area':  'rgba(255,245,250,0.98)',
      '--bg-input-row':   'rgba(200,80,120,0.06)',
      '--bg-msg-bot':     'rgba(255,240,248,0.9)',
      '--bg-msg-user':    '#f5c8d8',
      '--bg-typing':      'rgba(255,240,248,0.9)',
      '--bg-card':        'rgba(255,242,250,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#fff0f5 0%,#fce0ec 40%,#fde8f2 100%)',
      '--grad-r1':        'rgba(200,80,120,0.07)',
      '--grad-r2':        'rgba(220,100,140,0.05)',
      '--text-main':      '#4a1830',
      '--text-input':     '#380e22',
      '--text-ph':        'rgba(160,60,100,0.4)',
      '--accent':         '#c05070',
      '--accent2':        '#a03050',
      '--accent3':        '#d87090',
      '--border-header':  'rgba(200,80,120,0.2)',
      '--border-caps':    'rgba(200,80,120,0.15)',
      '--border-input':   'rgba(200,80,120,0.2)',
      '--border-input-f': 'rgba(200,80,120,0.55)',
      '--border-card':    'rgba(200,80,120,0.18)',
      '--border-chip':    'rgba(200,80,120,0.22)',
      '--online-border':  '#fff0f5',
      '--scrollbar':      'rgba(200,80,120,0.2)',
      '--send-grad':      'linear-gradient(135deg,#a03050,#c05070)',
      '--meta-color':     '#fff0f5',
    },
  },
  {
    id: 'ocean',
    name: '🌊 Ocean Deep',
    dark: {
      '--bg-body':        '#040e1a',
      '--bg-header':      'rgba(4,12,26,0.88)',
      '--bg-caps':        'rgba(4,10,22,0.7)',
      '--bg-input-area':  'rgba(2,6,14,0.94)',
      '--bg-input-row':   'rgba(80,160,220,0.05)',
      '--bg-msg-bot':     'rgba(180,230,255,0.05)',
      '--bg-msg-user':    '#0d2240',
      '--bg-typing':      'rgba(180,230,255,0.05)',
      '--bg-card':        'rgba(6,16,32,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#040e1a 0%,#071628 40%,#050f1c 100%)',
      '--grad-r1':        'rgba(50,140,220,0.1)',
      '--grad-r2':        'rgba(0,180,200,0.07)',
      '--text-main':      '#cce8f8',
      '--text-input':     '#e0f4ff',
      '--text-ph':        'rgba(80,160,220,0.35)',
      '--accent':         '#4eaadd',
      '--accent2':        '#2070b0',
      '--accent3':        '#78caf0',
      '--border-header':  'rgba(80,160,220,0.18)',
      '--border-caps':    'rgba(80,160,220,0.1)',
      '--border-input':   'rgba(80,160,220,0.12)',
      '--border-input-f': 'rgba(80,160,220,0.5)',
      '--border-card':    'rgba(80,160,220,0.2)',
      '--border-chip':    'rgba(80,160,220,0.2)',
      '--online-border':  '#040e1a',
      '--scrollbar':      'rgba(80,160,220,0.2)',
      '--send-grad':      'linear-gradient(135deg,#2070b0,#4eaadd)',
      '--meta-color':     '#040e1a',
    },
    light: {
      '--bg-body':        '#eef8ff',
      '--bg-header':      'rgba(232,248,255,0.95)',
      '--bg-caps':        'rgba(225,244,255,0.95)',
      '--bg-input-area':  'rgba(240,250,255,0.98)',
      '--bg-input-row':   'rgba(0,120,200,0.06)',
      '--bg-msg-bot':     'rgba(230,248,255,0.9)',
      '--bg-msg-user':    '#c0dff0',
      '--bg-typing':      'rgba(230,248,255,0.9)',
      '--bg-card':        'rgba(235,250,255,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#eef8ff 0%,#daf0ff 40%,#e4f5ff 100%)',
      '--grad-r1':        'rgba(0,120,200,0.07)',
      '--grad-r2':        'rgba(0,160,200,0.05)',
      '--text-main':      '#0a2840',
      '--text-input':     '#081e30',
      '--text-ph':        'rgba(0,100,180,0.4)',
      '--accent':         '#1c7ab8',
      '--accent2':        '#0a5a90',
      '--accent3':        '#3896cc',
      '--border-header':  'rgba(0,120,200,0.2)',
      '--border-caps':    'rgba(0,120,200,0.15)',
      '--border-input':   'rgba(0,120,200,0.2)',
      '--border-input-f': 'rgba(0,120,200,0.5)',
      '--border-card':    'rgba(0,120,200,0.18)',
      '--border-chip':    'rgba(0,120,200,0.22)',
      '--online-border':  '#eef8ff',
      '--scrollbar':      'rgba(0,120,200,0.2)',
      '--send-grad':      'linear-gradient(135deg,#0a5a90,#1c7ab8)',
      '--meta-color':     '#eef8ff',
    },
  },
  {
    id: 'forest',
    name: '🌿 Forest Dusk',
    dark: {
      '--bg-body':        '#080f08',
      '--bg-header':      'rgba(6,12,6,0.88)',
      '--bg-caps':        'rgba(4,10,4,0.7)',
      '--bg-input-area':  'rgba(2,6,2,0.94)',
      '--bg-input-row':   'rgba(80,160,80,0.05)',
      '--bg-msg-bot':     'rgba(180,240,180,0.05)',
      '--bg-msg-user':    '#0e200e',
      '--bg-typing':      'rgba(180,240,180,0.05)',
      '--bg-card':        'rgba(8,20,8,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#080f08 0%,#0e180a 40%,#0a1208 100%)',
      '--grad-r1':        'rgba(80,160,80,0.09)',
      '--grad-r2':        'rgba(40,120,60,0.07)',
      '--text-main':      '#cce8cc',
      '--text-input':     '#dff0df',
      '--text-ph':        'rgba(80,160,80,0.35)',
      '--accent':         '#62b862',
      '--accent2':        '#388838',
      '--accent3':        '#84d084',
      '--border-header':  'rgba(80,160,80,0.18)',
      '--border-caps':    'rgba(80,160,80,0.1)',
      '--border-input':   'rgba(80,160,80,0.12)',
      '--border-input-f': 'rgba(80,160,80,0.5)',
      '--border-card':    'rgba(80,160,80,0.2)',
      '--border-chip':    'rgba(80,160,80,0.2)',
      '--online-border':  '#080f08',
      '--scrollbar':      'rgba(80,160,80,0.2)',
      '--send-grad':      'linear-gradient(135deg,#388838,#62b862)',
      '--meta-color':     '#080f08',
    },
    light: {
      '--bg-body':        '#f0f8f0',
      '--bg-header':      'rgba(238,250,238,0.95)',
      '--bg-caps':        'rgba(232,248,232,0.95)',
      '--bg-input-area':  'rgba(244,252,244,0.98)',
      '--bg-input-row':   'rgba(40,140,40,0.06)',
      '--bg-msg-bot':     'rgba(238,252,238,0.9)',
      '--bg-msg-user':    '#c8e8c8',
      '--bg-typing':      'rgba(238,252,238,0.9)',
      '--bg-card':        'rgba(240,252,240,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#f0f8f0 0%,#e2f0e2 40%,#eaf4ea 100%)',
      '--grad-r1':        'rgba(40,140,40,0.07)',
      '--grad-r2':        'rgba(60,160,60,0.05)',
      '--text-main':      '#102010',
      '--text-input':     '#081808',
      '--text-ph':        'rgba(30,110,30,0.4)',
      '--accent':         '#2e8a2e',
      '--accent2':        '#1e6a1e',
      '--accent3':        '#46a846',
      '--border-header':  'rgba(40,140,40,0.2)',
      '--border-caps':    'rgba(40,140,40,0.15)',
      '--border-input':   'rgba(40,140,40,0.2)',
      '--border-input-f': 'rgba(40,140,40,0.5)',
      '--border-card':    'rgba(40,140,40,0.18)',
      '--border-chip':    'rgba(40,140,40,0.22)',
      '--online-border':  '#f0f8f0',
      '--scrollbar':      'rgba(40,140,40,0.2)',
      '--send-grad':      'linear-gradient(135deg,#1e6a1e,#2e8a2e)',
      '--meta-color':     '#f0f8f0',
    },
  },
  {
    id: 'aurora',
    name: '🔮 Aurora Violet',
    dark: {
      '--bg-body':        '#0c0814',
      '--bg-header':      'rgba(10,6,20,0.88)',
      '--bg-caps':        'rgba(8,4,16,0.7)',
      '--bg-input-area':  'rgba(4,2,10,0.94)',
      '--bg-input-row':   'rgba(150,90,220,0.05)',
      '--bg-msg-bot':     'rgba(220,200,255,0.05)',
      '--bg-msg-user':    '#1e1035',
      '--bg-typing':      'rgba(220,200,255,0.05)',
      '--bg-card':        'rgba(16,8,28,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#0c0814 0%,#120b1e 40%,#0e0a18 100%)',
      '--grad-r1':        'rgba(140,80,220,0.1)',
      '--grad-r2':        'rgba(80,40,180,0.07)',
      '--text-main':      '#ddd0f8',
      '--text-input':     '#ece4ff',
      '--text-ph':        'rgba(150,90,220,0.35)',
      '--accent':         '#a870e8',
      '--accent2':        '#7040c0',
      '--accent3':        '#c898f8',
      '--border-header':  'rgba(150,90,220,0.18)',
      '--border-caps':    'rgba(150,90,220,0.1)',
      '--border-input':   'rgba(150,90,220,0.12)',
      '--border-input-f': 'rgba(150,90,220,0.5)',
      '--border-card':    'rgba(150,90,220,0.2)',
      '--border-chip':    'rgba(150,90,220,0.2)',
      '--online-border':  '#0c0814',
      '--scrollbar':      'rgba(150,90,220,0.2)',
      '--send-grad':      'linear-gradient(135deg,#7040c0,#a870e8)',
      '--meta-color':     '#0c0814',
    },
    light: {
      '--bg-body':        '#f4f0ff',
      '--bg-header':      'rgba(246,242,255,0.95)',
      '--bg-caps':        'rgba(240,235,255,0.95)',
      '--bg-input-area':  'rgba(250,247,255,0.98)',
      '--bg-input-row':   'rgba(120,60,200,0.06)',
      '--bg-msg-bot':     'rgba(244,240,255,0.9)',
      '--bg-msg-user':    '#dac8f5',
      '--bg-typing':      'rgba(244,240,255,0.9)',
      '--bg-card':        'rgba(245,241,255,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#f4f0ff 0%,#e8e0ff 40%,#eee8ff 100%)',
      '--grad-r1':        'rgba(120,60,200,0.07)',
      '--grad-r2':        'rgba(80,40,180,0.05)',
      '--text-main':      '#280e50',
      '--text-input':     '#1c083a',
      '--text-ph':        'rgba(100,50,180,0.4)',
      '--accent':         '#7840c8',
      '--accent2':        '#5820a8',
      '--accent3':        '#9060dc',
      '--border-header':  'rgba(120,60,200,0.2)',
      '--border-caps':    'rgba(120,60,200,0.15)',
      '--border-input':   'rgba(120,60,200,0.2)',
      '--border-input-f': 'rgba(120,60,200,0.5)',
      '--border-card':    'rgba(120,60,200,0.18)',
      '--border-chip':    'rgba(120,60,200,0.22)',
      '--online-border':  '#f4f0ff',
      '--scrollbar':      'rgba(120,60,200,0.2)',
      '--send-grad':      'linear-gradient(135deg,#5820a8,#7840c8)',
      '--meta-color':     '#f4f0ff',
    },
  },
  {
    id: 'sunset',
    name: '🌅 Sunset Orange',
    dark: {
      '--bg-body':        '#150800',
      '--bg-header':      'rgba(20,8,0,0.88)',
      '--bg-caps':        'rgba(16,6,0,0.7)',
      '--bg-input-area':  'rgba(10,4,0,0.94)',
      '--bg-input-row':   'rgba(240,120,40,0.05)',
      '--bg-msg-bot':     'rgba(255,210,160,0.05)',
      '--bg-msg-user':    '#301500',
      '--bg-typing':      'rgba(255,210,160,0.05)',
      '--bg-card':        'rgba(24,10,0,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#150800 0%,#1e0e00 40%,#180a00 100%)',
      '--grad-r1':        'rgba(240,120,40,0.1)',
      '--grad-r2':        'rgba(220,60,20,0.07)',
      '--text-main':      '#f5dfc0',
      '--text-input':     '#fce8cc',
      '--text-ph':        'rgba(240,120,40,0.35)',
      '--accent':         '#f08040',
      '--accent2':        '#c05020',
      '--accent3':        '#f8a868',
      '--border-header':  'rgba(240,120,40,0.18)',
      '--border-caps':    'rgba(240,120,40,0.1)',
      '--border-input':   'rgba(240,120,40,0.12)',
      '--border-input-f': 'rgba(240,120,40,0.5)',
      '--border-card':    'rgba(240,120,40,0.2)',
      '--border-chip':    'rgba(240,120,40,0.2)',
      '--online-border':  '#150800',
      '--scrollbar':      'rgba(240,120,40,0.2)',
      '--send-grad':      'linear-gradient(135deg,#c05020,#f08040)',
      '--meta-color':     '#150800',
    },
    light: {
      '--bg-body':        '#fff5ea',
      '--bg-header':      'rgba(255,248,235,0.95)',
      '--bg-caps':        'rgba(255,242,225,0.95)',
      '--bg-input-area':  'rgba(255,250,240,0.98)',
      '--bg-input-row':   'rgba(200,90,20,0.06)',
      '--bg-msg-bot':     'rgba(255,246,232,0.9)',
      '--bg-msg-user':    '#f5d8b0',
      '--bg-typing':      'rgba(255,246,232,0.9)',
      '--bg-card':        'rgba(255,248,234,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#fff5ea 0%,#ffe8cc 40%,#ffeed8 100%)',
      '--grad-r1':        'rgba(200,90,20,0.07)',
      '--grad-r2':        'rgba(220,80,20,0.05)',
      '--text-main':      '#3a1800',
      '--text-input':     '#2a1000',
      '--text-ph':        'rgba(160,70,10,0.4)',
      '--accent':         '#c06020',
      '--accent2':        '#a04010',
      '--accent3':        '#d88040',
      '--border-header':  'rgba(200,90,20,0.2)',
      '--border-caps':    'rgba(200,90,20,0.15)',
      '--border-input':   'rgba(200,90,20,0.2)',
      '--border-input-f': 'rgba(200,90,20,0.5)',
      '--border-card':    'rgba(200,90,20,0.18)',
      '--border-chip':    'rgba(200,90,20,0.22)',
      '--online-border':  '#fff5ea',
      '--scrollbar':      'rgba(200,90,20,0.2)',
      '--send-grad':      'linear-gradient(135deg,#a04010,#c06020)',
      '--meta-color':     '#fff5ea',
    },
  },
  {
    id: 'cyan',
    name: '🩵 Midnight Cyan',
    dark: {
      '--bg-body':        '#021414',
      '--bg-header':      'rgba(2,18,18,0.88)',
      '--bg-caps':        'rgba(0,14,14,0.7)',
      '--bg-input-area':  'rgba(0,8,8,0.94)',
      '--bg-input-row':   'rgba(0,200,200,0.05)',
      '--bg-msg-bot':     'rgba(160,250,250,0.05)',
      '--bg-msg-user':    '#062828',
      '--bg-typing':      'rgba(160,250,250,0.05)',
      '--bg-card':        'rgba(4,22,22,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#021414 0%,#041e1e 40%,#031818 100%)',
      '--grad-r1':        'rgba(0,200,200,0.09)',
      '--grad-r2':        'rgba(0,160,180,0.07)',
      '--text-main':      '#b8f0f0',
      '--text-input':     '#d0f8f8',
      '--text-ph':        'rgba(0,200,200,0.35)',
      '--accent':         '#00cccc',
      '--accent2':        '#00909a',
      '--accent3':        '#40e0e0',
      '--border-header':  'rgba(0,200,200,0.18)',
      '--border-caps':    'rgba(0,200,200,0.1)',
      '--border-input':   'rgba(0,200,200,0.12)',
      '--border-input-f': 'rgba(0,200,200,0.5)',
      '--border-card':    'rgba(0,200,200,0.2)',
      '--border-chip':    'rgba(0,200,200,0.2)',
      '--online-border':  '#021414',
      '--scrollbar':      'rgba(0,200,200,0.2)',
      '--send-grad':      'linear-gradient(135deg,#00909a,#00cccc)',
      '--meta-color':     '#021414',
    },
    light: {
      '--bg-body':        '#e8ffff',
      '--bg-header':      'rgba(230,255,255,0.95)',
      '--bg-caps':        'rgba(220,252,252,0.95)',
      '--bg-input-area':  'rgba(238,255,255,0.98)',
      '--bg-input-row':   'rgba(0,160,170,0.06)',
      '--bg-msg-bot':     'rgba(228,255,255,0.9)',
      '--bg-msg-user':    '#b0e8e8',
      '--bg-typing':      'rgba(228,255,255,0.9)',
      '--bg-card':        'rgba(232,255,255,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#e8ffff 0%,#d0f4f4 40%,#dcfafa 100%)',
      '--grad-r1':        'rgba(0,160,170,0.07)',
      '--grad-r2':        'rgba(0,140,160,0.05)',
      '--text-main':      '#002830',
      '--text-input':     '#001e24',
      '--text-ph':        'rgba(0,130,140,0.4)',
      '--accent':         '#008890',
      '--accent2':        '#006870',
      '--accent3':        '#00a8b0',
      '--border-header':  'rgba(0,160,170,0.2)',
      '--border-caps':    'rgba(0,160,170,0.15)',
      '--border-input':   'rgba(0,160,170,0.2)',
      '--border-input-f': 'rgba(0,160,170,0.5)',
      '--border-card':    'rgba(0,160,170,0.18)',
      '--border-chip':    'rgba(0,160,170,0.22)',
      '--online-border':  '#e8ffff',
      '--scrollbar':      'rgba(0,160,170,0.2)',
      '--send-grad':      'linear-gradient(135deg,#006870,#008890)',
      '--meta-color':     '#e8ffff',
    },
  },
  {
    id: 'cherry',
    name: '🍒 Cherry Blossom',
    dark: {
      '--bg-body':        '#120006',
      '--bg-header':      'rgba(16,0,8,0.88)',
      '--bg-caps':        'rgba(12,0,6,0.7)',
      '--bg-input-area':  'rgba(8,0,4,0.94)',
      '--bg-input-row':   'rgba(240,40,80,0.05)',
      '--bg-msg-bot':     'rgba(255,180,200,0.05)',
      '--bg-msg-user':    '#2a0010',
      '--bg-typing':      'rgba(255,180,200,0.05)',
      '--bg-card':        'rgba(20,0,10,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#120006 0%,#1a000c 40%,#140008 100%)',
      '--grad-r1':        'rgba(240,40,80,0.1)',
      '--grad-r2':        'rgba(200,0,60,0.07)',
      '--text-main':      '#f8ccd8',
      '--text-input':     '#fcdde6',
      '--text-ph':        'rgba(240,60,100,0.35)',
      '--accent':         '#f04060',
      '--accent2':        '#c01840',
      '--accent3':        '#f87090',
      '--border-header':  'rgba(240,40,80,0.18)',
      '--border-caps':    'rgba(240,40,80,0.1)',
      '--border-input':   'rgba(240,40,80,0.12)',
      '--border-input-f': 'rgba(240,40,80,0.5)',
      '--border-card':    'rgba(240,40,80,0.2)',
      '--border-chip':    'rgba(240,40,80,0.2)',
      '--online-border':  '#120006',
      '--scrollbar':      'rgba(240,40,80,0.2)',
      '--send-grad':      'linear-gradient(135deg,#c01840,#f04060)',
      '--meta-color':     '#120006',
    },
    light: {
      '--bg-body':        '#fff0f3',
      '--bg-header':      'rgba(255,240,245,0.95)',
      '--bg-caps':        'rgba(255,232,240,0.95)',
      '--bg-input-area':  'rgba(255,245,248,0.98)',
      '--bg-input-row':   'rgba(200,20,60,0.06)',
      '--bg-msg-bot':     'rgba(255,238,244,0.9)',
      '--bg-msg-user':    '#f5b8cc',
      '--bg-typing':      'rgba(255,238,244,0.9)',
      '--bg-card':        'rgba(255,241,246,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#fff0f3 0%,#fdd8e4 40%,#fee4ec 100%)',
      '--grad-r1':        'rgba(200,20,60,0.07)',
      '--grad-r2':        'rgba(220,30,70,0.05)',
      '--text-main':      '#480018',
      '--text-input':     '#36000e',
      '--text-ph':        'rgba(180,20,60,0.4)',
      '--accent':         '#c82050',
      '--accent2':        '#a00038',
      '--accent3':        '#e04070',
      '--border-header':  'rgba(200,20,60,0.2)',
      '--border-caps':    'rgba(200,20,60,0.15)',
      '--border-input':   'rgba(200,20,60,0.2)',
      '--border-input-f': 'rgba(200,20,60,0.5)',
      '--border-card':    'rgba(200,20,60,0.18)',
      '--border-chip':    'rgba(200,20,60,0.22)',
      '--online-border':  '#fff0f3',
      '--scrollbar':      'rgba(200,20,60,0.2)',
      '--send-grad':      'linear-gradient(135deg,#a00038,#c82050)',
      '--meta-color':     '#fff0f3',
    },
  },
  {
    id: 'arctic',
    name: '🪨 Arctic Silver',
    dark: {
      '--bg-body':        '#0a0c10',
      '--bg-header':      'rgba(8,10,16,0.88)',
      '--bg-caps':        'rgba(6,8,12,0.7)',
      '--bg-input-area':  'rgba(4,5,8,0.94)',
      '--bg-input-row':   'rgba(160,180,210,0.05)',
      '--bg-msg-bot':     'rgba(200,215,240,0.05)',
      '--bg-msg-user':    '#141820',
      '--bg-typing':      'rgba(200,215,240,0.05)',
      '--bg-card':        'rgba(12,16,24,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#0a0c10 0%,#0e1218 40%,#0c1014 100%)',
      '--grad-r1':        'rgba(140,160,200,0.08)',
      '--grad-r2':        'rgba(100,120,180,0.06)',
      '--text-main':      '#c8d8f0',
      '--text-input':     '#dce8f8',
      '--text-ph':        'rgba(140,160,200,0.35)',
      '--accent':         '#98b4d8',
      '--accent2':        '#6080b0',
      '--accent3':        '#b8cce8',
      '--border-header':  'rgba(140,160,200,0.18)',
      '--border-caps':    'rgba(140,160,200,0.1)',
      '--border-input':   'rgba(140,160,200,0.12)',
      '--border-input-f': 'rgba(140,160,200,0.5)',
      '--border-card':    'rgba(140,160,200,0.2)',
      '--border-chip':    'rgba(140,160,200,0.2)',
      '--online-border':  '#0a0c10',
      '--scrollbar':      'rgba(140,160,200,0.2)',
      '--send-grad':      'linear-gradient(135deg,#6080b0,#98b4d8)',
      '--meta-color':     '#0a0c10',
    },
    light: {
      '--bg-body':        '#f0f4fa',
      '--bg-header':      'rgba(242,246,252,0.95)',
      '--bg-caps':        'rgba(235,242,250,0.95)',
      '--bg-input-area':  'rgba(245,249,255,0.98)',
      '--bg-input-row':   'rgba(80,110,170,0.06)',
      '--bg-msg-bot':     'rgba(238,244,255,0.9)',
      '--bg-msg-user':    '#c8d8f0',
      '--bg-typing':      'rgba(238,244,255,0.9)',
      '--bg-card':        'rgba(240,246,255,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#f0f4fa 0%,#e0eaf8 40%,#e8f0fa 100%)',
      '--grad-r1':        'rgba(80,110,170,0.07)',
      '--grad-r2':        'rgba(60,90,160,0.05)',
      '--text-main':      '#101828',
      '--text-input':     '#080e1c',
      '--text-ph':        'rgba(60,90,160,0.4)',
      '--accent':         '#4a6898',
      '--accent2':        '#2c4878',
      '--accent3':        '#6880b0',
      '--border-header':  'rgba(80,110,170,0.2)',
      '--border-caps':    'rgba(80,110,170,0.15)',
      '--border-input':   'rgba(80,110,170,0.2)',
      '--border-input-f': 'rgba(80,110,170,0.5)',
      '--border-card':    'rgba(80,110,170,0.18)',
      '--border-chip':    'rgba(80,110,170,0.22)',
      '--online-border':  '#f0f4fa',
      '--scrollbar':      'rgba(80,110,170,0.2)',
      '--send-grad':      'linear-gradient(135deg,#2c4878,#4a6898)',
      '--meta-color':     '#f0f4fa',
    },
  },
  {
    id: 'peach',
    name: '🍑 Peach Dream',
    dark: {
      '--bg-body':        '#160c06',
      '--bg-header':      'rgba(20,10,4,0.88)',
      '--bg-caps':        'rgba(16,8,2,0.7)',
      '--bg-input-area':  'rgba(10,5,0,0.94)',
      '--bg-input-row':   'rgba(240,160,100,0.05)',
      '--bg-msg-bot':     'rgba(255,220,180,0.05)',
      '--bg-msg-user':    '#2e1808',
      '--bg-typing':      'rgba(255,220,180,0.05)',
      '--bg-card':        'rgba(24,12,4,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#160c06 0%,#201006 40%,#1a0e04 100%)',
      '--grad-r1':        'rgba(240,160,100,0.09)',
      '--grad-r2':        'rgba(220,100,60,0.07)',
      '--text-main':      '#f5e0c8',
      '--text-input':     '#fceedd',
      '--text-ph':        'rgba(240,160,100,0.35)',
      '--accent':         '#e8a060',
      '--accent2':        '#c06830',
      '--accent3':        '#f0bc84',
      '--border-header':  'rgba(240,160,100,0.18)',
      '--border-caps':    'rgba(240,160,100,0.1)',
      '--border-input':   'rgba(240,160,100,0.12)',
      '--border-input-f': 'rgba(240,160,100,0.5)',
      '--border-card':    'rgba(240,160,100,0.2)',
      '--border-chip':    'rgba(240,160,100,0.2)',
      '--online-border':  '#160c06',
      '--scrollbar':      'rgba(240,160,100,0.2)',
      '--send-grad':      'linear-gradient(135deg,#c06830,#e8a060)',
      '--meta-color':     '#160c06',
    },
    light: {
      '--bg-body':        '#fff6ee',
      '--bg-header':      'rgba(255,248,238,0.95)',
      '--bg-caps':        'rgba(252,242,228,0.95)',
      '--bg-input-area':  'rgba(255,250,242,0.98)',
      '--bg-input-row':   'rgba(200,110,40,0.06)',
      '--bg-msg-bot':     'rgba(255,245,232,0.9)',
      '--bg-msg-user':    '#f5d8b4',
      '--bg-typing':      'rgba(255,245,232,0.9)',
      '--bg-card':        'rgba(255,246,234,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#fff6ee 0%,#fce8d0 40%,#feeedd 100%)',
      '--grad-r1':        'rgba(200,110,40,0.07)',
      '--grad-r2':        'rgba(220,100,40,0.05)',
      '--text-main':      '#3c1e04',
      '--text-input':     '#2c1400',
      '--text-ph':        'rgba(160,80,20,0.4)',
      '--accent':         '#c07030',
      '--accent2':        '#a05010',
      '--accent3':        '#d89050',
      '--border-header':  'rgba(200,110,40,0.2)',
      '--border-caps':    'rgba(200,110,40,0.15)',
      '--border-input':   'rgba(200,110,40,0.2)',
      '--border-input-f': 'rgba(200,110,40,0.5)',
      '--border-card':    'rgba(200,110,40,0.18)',
      '--border-chip':    'rgba(200,110,40,0.22)',
      '--online-border':  '#fff6ee',
      '--scrollbar':      'rgba(200,110,40,0.2)',
      '--send-grad':      'linear-gradient(135deg,#a05010,#c07030)',
      '--meta-color':     '#fff6ee',
    },
  },
  {
    id: 'lavender',
    name: '💜 Lavender Mist',
    dark: {
      '--bg-body':        '#0e0a14',
      '--bg-header':      'rgba(12,8,20,0.88)',
      '--bg-caps':        'rgba(10,6,16,0.7)',
      '--bg-input-area':  'rgba(6,4,10,0.94)',
      '--bg-input-row':   'rgba(180,140,220,0.05)',
      '--bg-msg-bot':     'rgba(220,200,255,0.05)',
      '--bg-msg-user':    '#1c1228',
      '--bg-typing':      'rgba(220,200,255,0.05)',
      '--bg-card':        'rgba(16,10,24,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#0e0a14 0%,#160e1e 40%,#120c18 100%)',
      '--grad-r1':        'rgba(180,140,220,0.09)',
      '--grad-r2':        'rgba(140,100,200,0.07)',
      '--text-main':      '#e0d0f8',
      '--text-input':     '#ecdeff',
      '--text-ph':        'rgba(180,140,220,0.35)',
      '--accent':         '#b890d8',
      '--accent2':        '#8860b0',
      '--accent3':        '#cca8e8',
      '--border-header':  'rgba(180,140,220,0.18)',
      '--border-caps':    'rgba(180,140,220,0.1)',
      '--border-input':   'rgba(180,140,220,0.12)',
      '--border-input-f': 'rgba(180,140,220,0.5)',
      '--border-card':    'rgba(180,140,220,0.2)',
      '--border-chip':    'rgba(180,140,220,0.2)',
      '--online-border':  '#0e0a14',
      '--scrollbar':      'rgba(180,140,220,0.2)',
      '--send-grad':      'linear-gradient(135deg,#8860b0,#b890d8)',
      '--meta-color':     '#0e0a14',
    },
    light: {
      '--bg-body':        '#f8f4ff',
      '--bg-header':      'rgba(250,246,255,0.95)',
      '--bg-caps':        'rgba(244,238,255,0.95)',
      '--bg-input-area':  'rgba(252,249,255,0.98)',
      '--bg-input-row':   'rgba(140,100,200,0.06)',
      '--bg-msg-bot':     'rgba(248,244,255,0.9)',
      '--bg-msg-user':    '#dccef0',
      '--bg-typing':      'rgba(248,244,255,0.9)',
      '--bg-card':        'rgba(249,245,255,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#f8f4ff 0%,#ece0ff 40%,#f2ecff 100%)',
      '--grad-r1':        'rgba(140,100,200,0.07)',
      '--grad-r2':        'rgba(120,80,190,0.05)',
      '--text-main':      '#200840',
      '--text-input':     '#16042e',
      '--text-ph':        'rgba(100,70,170,0.4)',
      '--accent':         '#8050c0',
      '--accent2':        '#6030a0',
      '--accent3':        '#9868d0',
      '--border-header':  'rgba(140,100,200,0.2)',
      '--border-caps':    'rgba(140,100,200,0.15)',
      '--border-input':   'rgba(140,100,200,0.2)',
      '--border-input-f': 'rgba(140,100,200,0.5)',
      '--border-card':    'rgba(140,100,200,0.18)',
      '--border-chip':    'rgba(140,100,200,0.22)',
      '--online-border':  '#f8f4ff',
      '--scrollbar':      'rgba(140,100,200,0.2)',
      '--send-grad':      'linear-gradient(135deg,#6030a0,#8050c0)',
      '--meta-color':     '#f8f4ff',
    },
  },
  {
    id: 'jade',
    name: '🌺 Jade Night',
    dark: {
      '--bg-body':        '#040f0a',
      '--bg-header':      'rgba(2,14,8,0.88)',
      '--bg-caps':        'rgba(2,10,6,0.7)',
      '--bg-input-area':  'rgba(0,6,4,0.94)',
      '--bg-input-row':   'rgba(60,180,120,0.05)',
      '--bg-msg-bot':     'rgba(160,250,200,0.05)',
      '--bg-msg-user':    '#0a2018',
      '--bg-typing':      'rgba(160,250,200,0.05)',
      '--bg-card':        'rgba(6,18,12,0.85)',
      '--body-bg-grad':   'linear-gradient(160deg,#040f0a 0%,#081a10 40%,#061408 100%)',
      '--grad-r1':        'rgba(40,180,120,0.09)',
      '--grad-r2':        'rgba(20,160,100,0.07)',
      '--text-main':      '#c0ecd8',
      '--text-input':     '#d8f4e8',
      '--text-ph':        'rgba(40,180,120,0.35)',
      '--accent':         '#40c890',
      '--accent2':        '#208860',
      '--accent3':        '#68dca8',
      '--border-header':  'rgba(40,180,120,0.18)',
      '--border-caps':    'rgba(40,180,120,0.1)',
      '--border-input':   'rgba(40,180,120,0.12)',
      '--border-input-f': 'rgba(40,180,120,0.5)',
      '--border-card':    'rgba(40,180,120,0.2)',
      '--border-chip':    'rgba(40,180,120,0.2)',
      '--online-border':  '#040f0a',
      '--scrollbar':      'rgba(40,180,120,0.2)',
      '--send-grad':      'linear-gradient(135deg,#208860,#40c890)',
      '--meta-color':     '#040f0a',
    },
    light: {
      '--bg-body':        '#eefaf4',
      '--bg-header':      'rgba(232,252,242,0.95)',
      '--bg-caps':        'rgba(224,248,236,0.95)',
      '--bg-input-area':  'rgba(240,253,246,0.98)',
      '--bg-input-row':   'rgba(0,150,90,0.06)',
      '--bg-msg-bot':     'rgba(228,252,240,0.9)',
      '--bg-msg-user':    '#b8e8d0',
      '--bg-typing':      'rgba(228,252,240,0.9)',
      '--bg-card':        'rgba(232,252,242,0.95)',
      '--body-bg-grad':   'linear-gradient(160deg,#eefaf4 0%,#d8f0e4 40%,#e4f8ec 100%)',
      '--grad-r1':        'rgba(0,150,90,0.07)',
      '--grad-r2':        'rgba(0,130,80,0.05)',
      '--text-main':      '#042e1a',
      '--text-input':     '#022212',
      '--text-ph':        'rgba(0,120,70,0.4)',
      '--accent':         '#0a8050',
      '--accent2':        '#006038',
      '--accent3':        '#189a68',
      '--border-header':  'rgba(0,150,90,0.2)',
      '--border-caps':    'rgba(0,150,90,0.15)',
      '--border-input':   'rgba(0,150,90,0.2)',
      '--border-input-f': 'rgba(0,150,90,0.5)',
      '--border-card':    'rgba(0,150,90,0.18)',
      '--border-chip':    'rgba(0,150,90,0.22)',
      '--online-border':  '#eefaf4',
      '--scrollbar':      'rgba(0,150,90,0.2)',
      '--send-grad':      'linear-gradient(135deg,#006038,#0a8050)',
      '--meta-color':     '#eefaf4',
    },
  },
];

export function getRandomThemeId() {
  const idx = Math.floor(Math.random() * THEMES.length);
  return THEMES[idx].id;
}

export function getThemeById(id) {
  return THEMES.find(t => t.id === id) || THEMES[0];
}

export function applyThemeTokens(themeId, mode) {
  const theme = getThemeById(themeId);
  const tokens = mode === 'light' ? theme.light : theme.dark;
  const root = document.documentElement;
  Object.entries(tokens).forEach(([key, val]) => {
    root.style.setProperty(key, val);
  });
  const metaTheme = document.querySelector('meta[name="theme-color"]');
  if (metaTheme) metaTheme.content = tokens['--meta-color'] || '#000';
}
